import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MediaInterface } from '../../../interfaces'

@Component({
  selector: 'dmmp-item-content',
  templateUrl: './item-content.component.html'
})
export class ItemContentComponent implements OnInit {

  @Input() relatedContent
  @Output() page = new EventEmitter()
  medias : MediaInterface[] = [
    {style: 'large', media: '(min-width: 1301px)'},
    {style: 'max_1300x1300', media: '(max-width: 1300px) AND (min-width: 651px)'},
    {style: 'max_650x650', media: '(max-width: 650px) AND (min-width: 326px)'},
    {style: 'max_325x325', media: '(max-width: 325px)'},
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
